export default __webpack_public_path__ + "static/media/workhub-latest-logo.f0db732d.png";